import React from 'react';
import '../survey-hub.css';

interface Props {
  isOwner: boolean;
  onSelectImport: () => void;
  onSelectBuilder: () => void;
  onSelectDashboard: () => void;
  onSelectQuickSurvey: () => void;
  onBack: () => void;
}

const STATS: Array<[string, string]> = [
  ['14', 'типов / шагов'],
  ['390px', 'мобильная ширина'],
  ['0', 'пустых кнопок'],
  ['1.71', 'версия'],
];

/**
 * Survey creation hub — template surveyStart() layout.
 * Styles: survey-hub.css
 */
export const CreateSurveyWorkflow: React.FC<Props> = ({
  isOwner,
  onSelectImport,
  onSelectBuilder,
  onSelectDashboard,
  onSelectQuickSurvey,
  onBack,
}) => {
  return (
    <div className="survey-hub-content" data-testid="survey-hub-start">
      <section className="survey-hub-hero">
        <div className="survey-hub-hero-main">
          <span className="survey-hub-kicker">Zertteu Academy · кабинет владельца</span>
          <h1>Создать исследовательский опрос</h1>
          <p>
            Расширение карточки «Программы и инструменты → Создать опрос». Сначала импорт или ручной
            конструктор; затем распознавание, только блокирующие уточнения, предпросмотр,
            утверждение и гостевая ссылка.
          </p>
        </div>
        <div className="survey-hub-hero-side">
          {STATS.map(([value, label]) => (
            <div key={label} className="survey-hub-stat">
              <b>{value}</b>
              <span>{label}</span>
            </div>
          ))}
        </div>
      </section>

      <div className="survey-hub-grid">
        <button
          type="button"
          className="survey-hub-card"
          style={{ ['--survey-hub-accent' as string]: '#41d2ff' }}
          onClick={onSelectImport}
        >
          <span className="ico" aria-hidden="true">
            ⇧
          </span>
          <h3>Импорт готового опроса</h3>
          <p>
            Word, Excel, текст или вставка вопросов. Система предложит структуру и сопоставление
            полей.
          </p>
          <em aria-hidden="true">→</em>
        </button>

        <button
          type="button"
          className="survey-hub-card"
          style={{ ['--survey-hub-accent' as string]: '#49ddb7' }}
          onClick={onSelectBuilder}
        >
          <span className="ico" aria-hidden="true">
            ＋
          </span>
          <h3>Создать вручную</h3>
          <p>
            Открытый текст, одиночный и множественный выбор, шкала, матрица и дата — с точным
            предпросмотром респондента.
          </p>
          <em aria-hidden="true">→</em>
        </button>

        <button
          type="button"
          className="survey-hub-card"
          style={{ ['--survey-hub-accent' as string]: '#9e80ff' }}
          onClick={onSelectDashboard}
        >
          <span className="ico" aria-hidden="true">
            ▦
          </span>
          <h3>Мои опросы и результаты</h3>
          <p>
            Гостевые ссылки, статусы, ответы, выгрузка и базовая аналитика исследования.
          </p>
          <em aria-hidden="true">→</em>
        </button>

        {isOwner ? (
          <button
            type="button"
            className="survey-hub-card"
            style={{ ['--survey-hub-accent' as string]: '#e2ad3a' }}
            onClick={onSelectQuickSurvey}
          >
            <span className="ico" aria-hidden="true">
              ✦
            </span>
            <h3>Быстрый служебный опрос</h3>
            <p>
              Текстом или голосом: «создай опрос для докторантов 1 курса…». До утверждения — только
              черновик.
            </p>
            <em aria-hidden="true">→</em>
          </button>
        ) : null}
      </div>

      <div className="survey-hub-panel" style={{ marginTop: 13 }}>
        <header>
          <div className="grow">
            <h3>Текущая схема</h3>
            <p>Не отдельный новый продукт — расширение уже существующего исследовательского контура.</p>
          </div>
          <span className="survey-hub-chip ok">Карточка сохранена</span>
        </header>
        <div className="survey-hub-chiprow">
          <span className="survey-hub-chip">Программы и инструменты</span>
          <span className="survey-hub-chip">→</span>
          <span className="survey-hub-chip">Создать опрос</span>
          <span className="survey-hub-chip">→</span>
          <span className="survey-hub-chip gold">Импорт / конструктор</span>
          <span className="survey-hub-chip">→ Предпросмотр → Утверждение → Гостевая ссылка</span>
        </div>
      </div>

      <div className="survey-hub-actions" style={{ marginTop: 12 }}>
        <button type="button" className="survey-hub-btn" onClick={onBack}>
          ← Назад в меню инструментов
        </button>
      </div>
    </div>
  );
};
